import React from 'react';
import { StyledContentBox } from './ContentBox.style';

const ContentBox = (props) => {
  return <StyledContentBox>{props.children}</StyledContentBox>;
};

export default ContentBox;
